import { LanguageModel } from '../models/LanguageModel';

export const languages: LanguageModel[] = [
  { code: 'bg', name: 'Bulgarian', countryCode: 'BG' },
  { code: 'cs', name: 'Czech', countryCode: 'CZ' },
  { code: 'da', name: 'Danish', countryCode: 'DK' },
  { code: 'de', name: 'German', countryCode: 'DE' },
  { code: 'el', name: 'Greek', countryCode: 'GR' },
  { code: 'en', name: 'English', countryCode: 'US' },
  { code: 'es', name: 'Spanish', countryCode: 'ES' },
  { code: 'fi', name: 'Finnish', countryCode: 'FI' },
  { code: 'fr', name: 'French', countryCode: 'FR' },
  { code: 'hu', name: 'Hungarian', countryCode: 'HU' },
  { code: 'id', name: 'Indonesian', countryCode: 'ID' },
  { code: 'it', name: 'Italian', countryCode: 'IT' },
  { code: 'ja', name: 'Japanese', countryCode: 'JP' },
  { code: 'ko', name: 'Korean', countryCode: 'KR' },
  { code: 'ms', name: 'Malay', countryCode: 'MY' },
  { code: 'nl', name: 'Dutch', countryCode: 'NL' },
  { code: 'no', name: 'Norwegian', countryCode: 'NO' },
  { code: 'pl', name: 'Polish', countryCode: 'PL' },
  { code: 'pt', name: 'Portuguese', countryCode: 'PT' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', countryCode: 'BR' },
  { code: 'ro', name: 'Romanian', countryCode: 'RO' },
  { code: 'ru', name: 'Russian', countryCode: 'RU' },
  { code: 'sk', name: 'Slovak', countryCode: 'SK' },
  { code: 'sr', name: 'Serbian', countryCode: 'RS' },
  { code: 'sv', name: 'Swedish', countryCode: 'SE' },
  { code: 'ta', name: 'Tamil', countryCode: 'IN' },
  { code: 'th', name: 'Thai', countryCode: 'TH' },
  { code: 'tr', name: 'Turkish', countryCode: 'TR' },
  { code: 'vi', name: 'Vietnamese', countryCode: 'VN' },
  { code: 'zh', name: 'Chinese', countryCode: 'CN' },
  { code: 'zh-CHS', name: 'Chinese (Simplified)', countryCode: 'CN' },
  { code: 'zh-CHT', name: 'Chinese (Traditional)', countryCode: 'TW' },
];